"use strict";
/**
 *
 * useSafeState
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/** Safely manages the state by checking if the component is mounted before calling `setState`. */
function useSafeState(initialState) {
    const mounted = react_1.useRef(true);
    react_1.useEffect(() => () => {
        mounted.current = false;
    }, []);
    const [state, internalSetState] = react_1.useState(initialState);
    const setState = react_1.useCallback((action) => {
        if (mounted.current) {
            internalSetState(action);
        }
    }, [internalSetState]);
    return [state, setState];
}
exports.useSafeState = useSafeState;
